import { Flex } from "@mantine/core";

import style from "./customers.module.css";

import MetisLogo from "./../../../../assets/MetisCustomer.webp";
import FroyaLogo from "./../../../../assets/FroyaCustomer.svg";
import HasvikLogo from "./../../../../assets/HasvikCustomer.webp";
import NordlandFylkeskommuneLogo from "./../../../../assets/NordlandFylkeskommuneCustomer.webp";
import RaseborgLogo from "./../../../../assets/RaseborgCustomer.svg";
import SomnaLogo from "./../../../../assets/SomnaCustomer.svg";
import WangLogo from "./../../../../assets/WangCustomer.webp";
import FridhemLogo from "./../../../../assets/FridhemCustomer.webp";
import ValSkolerLogo from "./../../../../assets/ValSkolerCustomer.webp";

const CustomersSegment = () => {
    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.flex}>
                    <div className={style.flexRow}>
                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={SomnaLogo} alt="Sømna Kommune"></img>
                        </Flex>

                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={WangLogo} alt="Wang Videregående skoler"></img>
                        </Flex>

                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={NordlandFylkeskommuneLogo} alt="Metis Videregående"></img>
                        </Flex>

                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={HasvikLogo} alt="Hasvik Kommune"></img>
                        </Flex>
                    </div>

                    <div className={style.flexRow}>
                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={FroyaLogo} alt="Frøya Kommune"></img>
                        </Flex>

                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={RaseborgLogo} alt="Raseborg skolar"></img>
                        </Flex>

                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={FridhemLogo} alt="Fridhems folkhögskola"></img>
                        </Flex>

                        <Flex justify={"center"} align={"center"} w={"100%"} className={style.logoWrapper}>
                            <img className={style.logo} src={ValSkolerLogo} alt="Val Skoler"></img>
                        </Flex>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomersSegment;
